// Modules
import { Suspense } from 'react';
import { useRoutes } from 'hookrouter';
import "@fontsource/lato/300.css"
import { BaseLayout } from 'layouts';
import { NotFound, Loading } from 'pages';
import routes from 'routes';
import Particles from 'react-tsparticles'
import particleSettings from 'components/particleSettings'
import { ThemeProvider } from 'styled-components';
import { lightTheme, darkTheme } from 'styles/theme';
import { GlobalStyles } from 'styles/global';
import { useDarkMode } from 'useDarkMode';

function App() {
  const routeResult = useRoutes(routes);

  const [ isDarkMode, toggleTheme, componentMounted ] = useDarkMode();
  const themeMode = isDarkMode === 'light' ? lightTheme : darkTheme;

  if (!componentMounted) {
    return <div />
  };

  return (
    <ThemeProvider theme={themeMode}>
      <GlobalStyles />
        <Particles options={particleSettings}/>
          <BaseLayout className="BaseLayout" toggleTheme={toggleTheme} isDarkMode={isDarkMode} >
            <Suspense fallback={<Loading/>}>
              {routeResult || <NotFound/>}
            </Suspense>
          </BaseLayout>
    </ThemeProvider>
  );
}

export default App;
